import { Injectable } from '@angular/core';
import { AppIcons, IIcons } from '@datachain/ui-sdk/components/dc-icon';

export enum DcIcons {
	Absent = 'absent',
	Access = 'access',
	AddCircle = 'add-circle',
	Admin = 'admin',
	AddElement = 'add-element',
	AddElementV2 = 'add-element-v2',
	Cache = 'cache',
	Cancel = 'cancel',
	CardView = 'card-view',
	Check = 'check',
	Column = 'column',
	Common = 'Common',
	Context = 'Context',
	CopyFile = 'copy-file',
	Collapse = 'collapse',
	CollapseAll = 'collapse-all',
	Close = 'close',
	Date = 'date',
	Delete = 'delete',
	DeleteForever = 'delete-forever',
	Details = 'details',
	DetectSchema = 'detect-schema',
	DetectAnomalies = 'detect-anomalies',
	DeSelectAll = 'deselected-action',
	Edit = 'edit',
	Error = 'error',
	Encrypted = 'encrypted',
	Email = 'email',
	Expand = 'expand',
	ExpandAll = 'expand-all',
	Export = 'export',
	ExposeDatablock = 'datablock-expose-element',
	Favorite = 'favorite',
	FavoriteFilled = 'favorite-filled',
	Filter = 'filter',
	FilterOff = 'filter-off',
	Flash = 'flash',
	FlashOff = 'flash-off',
	FixWizard = 'fix-wizard',
	Formula = 'formula',
	Group = 'group',
	GroupingTag = 'grouping-tag',
	Info = 'info',
	InfoRounded = 'info-rounded',
	Input = 'input',
	Key = 'key',
	Keep = 'keep',
	KeepFilled = 'keep-filled',
	KeepOn = 'keep-active',
	KeepOff = 'keep-inactive',
	ListView = 'list-view',
	LockOpen = 'lock-open',
	LockClose = 'lock-close',
	MenuMoreOptionsHandle = 'menu-more-options-open-handle',
	MoveUp = 'move-up',
	MoveDown = 'move-down',
	MoveTop = 'move-top',
	MoveBottom = 'move-bottom',
	NotUsed = 'not-used',
	NotSynced = 'not-synced',
	Notifying = 'notifying',
	OpenInNewTab = 'open-in-new-tab',
	Output = 'output',
	Paused = 'paused',
	Pending = 'pending',
	Profile = 'profile',
	Project = 'project',
	ProjectOpen = 'project-open',
	ProjectDetails = 'project-details',
	Publish = 'publish',
	ResetSelection = 'reset-selection',
	RunningTask = 'running-task',
	Ranking = 'ranking',
	ResetText = 'reset-text',
	Resume = 'resume',
	Save = 'save',
	Settings = 'settings',
	SelectAll = 'selected-action',
	SpellCheck = 'spell-check',
	Share = 'share',
	ShareOff = 'share-off',
	StackedFormula = 'stacked-formula',
	StopAction = 'stop-action',
	Subscription = 'subscription',
	Synced = 'synced',
	SwitchVersion = 'switch-version',
	TableRows = 'table-rows',
	Task = 'task',
	TestApi = 'test-api',
	Member = 'member',
	Update = 'update',
	URLs = 'urls',
	User = 'user',
	Version = 'version',
	View = 'view',
	ViewCarousel = 'view-carouse',
	Warning = 'warning',
	WarningMessage = 'warning-message',
}

@Injectable()
export class AppDcIcons extends AppIcons {
	private readonly path = './src/img';

	protected icons: IIcons = {
		[DcIcons.Absent]: `${this.path}/common/absent_48dp_5F6368_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Access]: `${this.path}/common/key_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.AddElement]: `${this.path}/common/add_circle_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.AddElementV2]: `${this.path}/common/list_alt_add_48dp_5F6368_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Admin]: `${this.path}/project/manage_accounts_48dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.AddCircle]: `${this.path}/common/add_circle_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Cache]: `${this.path}/common/memory_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Cancel]: `${this.path}/common/cancel_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.CardView]: `${this.path}/project/grid_on_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Check]: `${this.path}/common/check_circle_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Column]: `${this.path}/common/view_column_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Common]: `${this.path}/genericsData-color-solo.svg`,
		[DcIcons.Context]: `${this.path}/common/manufacturing_48dp_000000_FILL0_wght400_GRAD200_opsz48.svg`,
		[DcIcons.CopyFile]: `${this.path}/common/file_copy_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Collapse]: `${this.path}/common/keyboard_arrow_down_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.CollapseAll]: `${this.path}/common/collapse_all_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Close]: `${this.path}/common/close_black_24dp.svg`,
		[DcIcons.Date]: `${this.path}/project/event_available_48dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Delete]: `${this.path}/common/delete_FILL0_wght400_GRAD0_opsz24.svg`,
		[DcIcons.DeleteForever]: `${this.path}/common/delete_forever_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Details]: `${this.path}/common/info_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.DetectSchema]: `${this.path}/common/schema_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.DetectAnomalies]: `${this.path}/common/verified_user_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.DeSelectAll]: `${this.path}/common/check_box_outline_blank_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Edit]: `${this.path}/common/edit_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Error]: `${this.path}/common/error_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Encrypted]: `${this.path}/common/encrypted_48dp_E3E3E3_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Email]: `${this.path}/project/forward_to_inbox_48dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Expand]: `${this.path}/common/chevron_forward_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.ExpandAll]: `${this.path}/common/expand_all_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Export]: `${this.path}/common/export_notes_48dp_000000_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.ExposeDatablock]: `${this.path}/datablock/icon-api-config.svg`,
		[DcIcons.Favorite]: `${this.path}/project/favorite_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.FavoriteFilled]: `${this.path}/project/favorite_48dp_000000_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Filter]: `${this.path}/common/filter_alt_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.FilterOff]: `${this.path}/common/filter_alt_off_48dp.svg`,
		[DcIcons.Flash]: `${this.path}/common/flash_on_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.FlashOff]: `${this.path}/common/flash_off_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.FixWizard]: `${this.path}/common/wand_stars_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Formula]: `${this.path}/svg/icon-formula.svg`,
		[DcIcons.Group]: `${this.path}/common/groups_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.GroupingTag]: `${this.path}/common/bookmarks_24dp__FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Info]: `${this.path}/common/chat_info_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.InfoRounded]: `${this.path}/project/info_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Input]: `${this.path}/common/input_circle_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Key]: `${this.path}/common/key_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Keep]: `${this.path}/project/keep_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.KeepFilled]: `${this.path}/project/keep_48dp_000000_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.KeepOn]: `${this.path}/common/keep_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.KeepOff]: `${this.path}/common/keep_off_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.ListView]: `${this.path}/project/list_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.LockOpen]: `${this.path}/common/lock_open_right_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.LockClose]: `${this.path}/common/lock_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.MenuMoreOptionsHandle]: `${this.path}/common/more_vert_FILL0_wght400_GRAD0_opsz24.svg`,
		[DcIcons.MoveUp]: `${this.path}/common/arrow_up_48dp_5F6368_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.MoveDown]: `${this.path}/common/arrow_down_48dp_5F6368_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.MoveTop]: `${this.path}/common/arrow_top_48dp_5F6368_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.MoveBottom]: `${this.path}/common/arrow_bottom_48dp_5F6368_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.NotUsed]: `${this.path}/common/not_used_48dp_5F6368_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.NotSynced]: `${this.path}/common/sync_problem_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Notifying]: `${this.path}/common/podcasts_48dp__FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Save]: `${this.path}/common/save_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Settings]: `${this.path}/common/settings_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.SelectAll]: `${this.path}/common/check_box_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Share]: `${this.path}/common/share_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.ShareOff]: `${this.path}/common/share_off_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.SpellCheck]: `${this.path}/common/spellcheck_48dp_000000_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.StackedFormula]: `${this.path}/common/dc-formula.svg`,
		[DcIcons.StopAction]: `${this.path}/common/stop_circle_48dp_5F6368_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Subscription]: `${this.path}/common/subscription_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Synced]: `${this.path}/common/sync_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.SwitchVersion]: `${this.path}/common/version_48dp__FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.TableRows]: `${this.path}/common/table_rows_narrow_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Task]: `${this.path}/common/task_48dp_5F6368_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.TestApi]: `${this.path}/common/experiment_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Member]: `${this.path}/common/experiment_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.OpenInNewTab]: `${this.path}/common/open_in_new_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Output]: `${this.path}/common/output_circle_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Paused]: `${this.path}/common/paused_48dp_5F6368_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Pending]: `${this.path}/common/pending_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Profile]: `${this.path}/common/profile_48dp_5F6368_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Project]: `${this.path}/common/project_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.ProjectOpen]: `${this.path}/project/folder_open_48dp_000000_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.ProjectDetails]: `${this.path}/common/folder_eye_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Publish]: `${this.path}/common/publish_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Ranking]: `${this.path}/datablock/sync_alt_48dp_5F6368_FILL0_wght500_GRAD0_opsz48.svg`,
		[DcIcons.ResetSelection]: `${this.path}/common/reset_settings_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.ResetText]: `${this.path}/common/rotate_auto_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Resume]: `${this.path}/common/resume_circle_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.RunningTask]: `${this.path}/common/av_timer_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Update]: `${this.path}/common/update_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.URLs]: `${this.path}/common/http_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.User]: `${this.path}/common/person_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Version]: `${this.path}/project/conversion_path_48dp_000000_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.View]: `${this.path}/common/visibility_24dp_FILL0_wght400_GRAD0_opsz24.svg`,
		[DcIcons.ViewCarousel]: `${this.path}/common/view_carousel_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Warning]: `${this.path}/common/warning_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.WarningMessage]: `${this.path}/common/emergency_home_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
	};
}
